'use client';
import type { NewsComments } from '@/types';

import React from 'react';
import { useRouter } from 'next/navigation';

import SendComment from '../SendComment';
import UserComments from '../UserComments';

import { Box, Grid, GridItem, Text } from '@/components';
import {
  useGetRateNew,
  usePostRateNew,
  useProfile,
  useTranslation,
} from '@/hooks';
import Star from '@/svgs/Star 12.svg';
import GrayStar from '@/svgs/Star 13.svg';
import GoldStar from '@/svgs/Star 14.svg';

const BlogsComments: React.FC<{
  comment: boolean;
  newsId: string;
  comments: NewsComments[];
}> = ({ comment, newsId, comments }) => {
  const { t } = useTranslation('pages.blog');
  const [stateRate, setStateRate] = React.useState<number | null>(null);
  const router = useRouter();
  const { mutateAsync: postRate } = usePostRateNew();
  const { mutateAsync: getRate } = useGetRateNew();
  const ArrayStar = [5, 4, 3, 2, 1];
  const submitRate = async (rate: number) => {
    setStateRate(rate);
    await postRate({ news_id: newsId, rate });
    router.refresh();
  };
  const { data: profile } = useProfile();
  React.useEffect(() => {
    if (profile) {
      void getRate({ news_id: newsId }).then((res) => {
        setStateRate(res.rate);
      });
    }
  }, [newsId]);

  return (
    <>
      {profile && (
        <>
          <Text textAlign={'center'} fontSize="lg" marginLeft="27px" mt="40px">
            {t('yourScore')}:
          </Text>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={'12px'}
            marginBottom={{ base: '33px', lg: '40px' }}
          >
            {ArrayStar.map((item) => (
              <Box
                onClick={() => void submitRate(item)}
                key={item}
                sx={{
                  zIndex: 'docked',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
                display="flex"
                flexDirection="column"
                alignItems="center"
                paddingLeft="8px"
              >
                {stateRate === null ? (
                  <Star w="35px" h="35px" />
                ) : item <= stateRate ? (
                  <GoldStar w="35px" h="35px" />
                ) : (
                  <GrayStar w="35px" h="35px" />
                )}
              </Box>
            ))}
          </Box>
        </>
      )}

      <Box
        mt={{ base: '33px', lg: '40px' }}
        mb="53px"
        gap="5"
        display="inline-block"
        borderBottom={'2px solid'}
        paddingInlineEnd="20px"
        paddingBottom="7px"
        borderBottomColor={'secondary.500'}
      >
        <Text fontSize="lg" minWidth="max-content">
          {t('comments')}
        </Text>
      </Box>

      <Grid templateColumns={{ base: '1fr', lg: '35% 1fr' }} gap={8}>
        <GridItem
          colSpan={1}
          borderLeft={{ base: 'none', lg: '1px solid' }}
          borderBottom={{ base: '1px solid', lg: 'none' }}
          borderBottomColor={{ base: 'primary.50', lg: 'none' }}
          borderLeftColor={{ base: 'none', lg: 'primary.50' }}
          ml={{ base: 5, lg: 0 }}
          pl={{ base: 0, lg: 5 }}
          pb={{ base: 10, lg: 0 }}
        >
          <SendComment comment={comment} newsId={newsId} />
        </GridItem>
        <GridItem colSpan={1} pl={5}>
          <UserComments comments={comments} />
        </GridItem>
      </Grid>
    </>
  );
};
export default BlogsComments;
